(function () {
  'use strict';

  if (window.KingFandomCalendarPastEventsLoaded) return;
  window.KingFandomCalendarPastEventsLoaded = true;

  var PACIFIC_TIME_ZONE = 'America/Los_Angeles';
  var MONTHS = {
    january: 1,
    february: 2,
    march: 3,
    april: 4,
    may: 5,
    june: 6,
    july: 7,
    august: 8,
    september: 9,
    october: 10,
    november: 11,
    december: 12
  };

  function getPacificDateParts() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: PACIFIC_TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());
    var values = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = part.value;
    });

    return values;
  }

  function getPacificDateKey() {
    var values = getPacificDateParts();
    return Number(values.year + values.month + values.day);
  }

  function getCalendarMonthAndYear(calendar) {
    var section = calendar.closest('.kf-section');
    var heading = section && section.querySelector('.kf-title');
    var match = heading && heading.textContent.trim().match(/^([A-Za-z]+)\s+(\d{4})$/);

    if (!match) return null;

    var month = MONTHS[match[1].toLowerCase()];
    var year = Number(match[2]);

    if (!month || !year) return null;

    return { month: month, year: year };
  }

  function addPastLabel(card) {
    if (card.querySelector('.kf-calendar__past-label')) return;

    var label = document.createElement('span');
    label.className = 'kf-calendar__past-label';
    label.textContent = 'Past event';
    card.appendChild(label);
  }

  function disablePastLink(card) {
    if (card.tagName !== 'A') return;

    card.removeAttribute('href');
    card.setAttribute('aria-disabled', 'true');
    card.setAttribute('tabindex', '-1');
  }

  function updatePastEvents() {
    var todayKey = getPacificDateKey();

    document.querySelectorAll('.kf-calendar').forEach(function (calendar) {
      var calendarDate = getCalendarMonthAndYear(calendar);
      if (!calendarDate) return;

      calendar.querySelectorAll('.kf-calendar__day--active').forEach(function (card) {
        var number = card.querySelector('.kf-calendar__number');
        var day = number ? Number(number.textContent.trim()) : 0;
        if (!day) return;

        var eventKey = calendarDate.year * 10000 + calendarDate.month * 100 + day;
        var isPast = card.classList.contains('is-past') || eventKey < todayKey;

        if (!isPast) return;

        card.classList.add('is-past');
        card.classList.remove('is-highlighted');
        disablePastLink(card);
        addPastLabel(card);
      });
    });
  }

  function monthLabel(monthKey) {
    var parts = monthKey.split('-');
    var date = new Date(Number(parts[0]), Number(parts[1]) - 1, 1);
    return new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(date);
  }

  function initializeWaitlistMonthFilter() {
    document.querySelectorAll('[data-kf-required-group="dates"]').forEach(function (fieldset) {
      if (fieldset.querySelector('[data-kf-waitlist-month-select]')) return;

      var dateLabels = Array.prototype.slice.call(fieldset.querySelectorAll('[data-kf-waitlist-date]'));
      if (!dateLabels.length) return;

      var months = [];
      dateLabels.forEach(function (label) {
        var date = label.getAttribute('data-kf-waitlist-date') || '';
        var month = date.slice(0, 7);
        if (/^\d{4}-\d{2}$/.test(month) && months.indexOf(month) === -1) months.push(month);
      });
      months.sort();
      if (!months.length) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'kf-contact-form__field kf-waitlist-month-filter';

      var label = document.createElement('label');
      label.setAttribute('for', 'KfWaitlistMonth');
      label.textContent = 'Month';

      var select = document.createElement('select');
      select.id = 'KfWaitlistMonth';
      select.setAttribute('data-kf-waitlist-month-select', '');

      months.forEach(function (month) {
        var option = document.createElement('option');
        option.value = month;
        option.textContent = monthLabel(month);
        select.appendChild(option);
      });

      wrapper.appendChild(label);
      wrapper.appendChild(select);
      fieldset.insertBefore(wrapper, dateLabels[0]);

      var pacific = getPacificDateParts();
      var currentMonth = pacific.year + '-' + pacific.month;
      select.value = months.indexOf(currentMonth) !== -1 ? currentMonth : months[0];

      function updateVisibleDates() {
        var selectedMonth = select.value;
        var today = getPacificDateParts();
        var todayIso = today.year + '-' + today.month + '-' + today.day;

        dateLabels.forEach(function (dateLabel) {
          var iso = dateLabel.getAttribute('data-kf-waitlist-date') || '';
          var expired = iso < todayIso;
          var wrongMonth = iso.slice(0, 7) !== selectedMonth;
          dateLabel.hidden = expired || wrongMonth;

          var input = dateLabel.querySelector('input');
          if (input) {
            input.disabled = expired;
            if (expired) input.checked = false;
          }
        });
      }

      select.addEventListener('change', updateVisibleDates);
      updateVisibleDates();
      window.setInterval(updateVisibleDates, 60000);
    });
  }

  document.addEventListener('click', function (event) {
    var card = event.target.closest('a.kf-calendar__day.is-past');
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updatePastEvents();
      initializeWaitlistMonthFilter();
    });
  } else {
    updatePastEvents();
    initializeWaitlistMonthFilter();
  }

  window.setInterval(updatePastEvents, 60000);
}());
